export class TrafficInfo {
	constructor(public readonly source = "", public readonly medium = "") {
		// intentionally left empty
	}

	doesSourceExist(): boolean {
		return this.source.length > 0;
	}

	toPageNameFragment(): string {
		return ":::" + this.source + "-" + this.medium;
	}
}
